import styled from 'styled-components'
import { colors } from 'Common/constants'

export const Username = styled.small`
  color: ${colors.main};
  text-transform: uppercase;
  font-weight: bold;
  margin-left: 0.5rem;
`
